var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranscribationRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 15.3125C19.3211 15.3125 21 13.6336 21 11.5625C21 9.49143 19.3211 7.8125 17.25 7.8125C15.1789 7.8125 13.5 9.49143 13.5 11.5625C13.5 13.6336 15.1789 15.3125 17.25 15.3125ZM17.25 15.3125H6.75M6.75 15.3125C8.82107 15.3125 10.5 13.6336 10.5 11.5625C10.5 9.49143 8.82107 7.8125 6.75 7.8125C4.67893 7.8125 3 9.49143 3 11.5625C3 13.6336 4.67893 15.3125 6.75 15.3125Z",
    stroke: "#697180",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscribationRecord);
export default __webpack_public_path__ + "static/media/transcribation_record.ac6d352f698b1d36a1d310800922fa28.svg";
export { ForwardRef as ReactComponent };